<script setup>
import { computed } from 'vue';
import { formataMoedaReais } from '@kodatec/brasil-utils';
import { status_solicitacao_pendente } from '@/commons/projetos';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})

// A inclusão acontece na aprovação: depois de analisada, a solicitação não tem mais o que incluir.
const aguardandoAnalise = computed(() => props.solicitacao.ultimo_status === status_solicitacao_pendente);

const rubricasNovas = computed(() =>
    aguardandoAnalise.value ? (props.solicitacao.dados.rubricas ?? []).filter((rubrica) => rubrica.nova_rubrica) : []
);

const nomesRubricasNovas = computed(() => rubricasNovas.value.map((rubrica) => rubrica.rubrica_nome).join(', '));
</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados titulo="Valor Total"
        :conteudo="props.solicitacao.dados.valor ? formataMoedaReais(props.solicitacao.dados.valor) : 'Não informado'" />

    <LabelDados titulo="Justificativa" v-if="props.solicitacao.dados.justificativa"
        :conteudo="props.solicitacao.dados.justificativa" tamanho_div="col-12" />

    <div v-if="props.solicitacao.dados.rubricas?.length" class="w-full">
        <hr class="w-full border-solid border-top-1 border-bottom-none surface-border mb-3 mt-3" />
        <h3 class="text-900 font-bold text-sm pb-0 mb-1 col-12">Distribuição por Rubrica</h3>
        <p class="text-500 pt-0 font-medium text-xs mt-0 mb-3 col-12">Detalhamento dos valores retirados, discriminados
            por rubrica.</p>

        <CardInformacao v-if="rubricasNovas.length" classeColuna="col-12 mb-3" severidade="alerta"
            :titulo="rubricasNovas.length > 1 ? 'Serão incluídas no projeto ao aprovar:' : 'Será incluída no projeto ao aprovar:'"
            :valor="nomesRubricasNovas" icone="pi pi-exclamation-circle" />

        <TabelaScrollContainer>
            <DataTable :value="props.solicitacao.dados.rubricas" size="small" striped-rows>
                <Column field="rubrica_nome" header="Rubrica">
                    <template #body="{ data }">
                        <div class="flex align-items-center gap-4">
                            <ColunaListas :titulo="data.rubrica_nome" :descricao="`Código: ${data.rubrica_codigo}`" />
                            <Tag v-if="aguardandoAnalise && data.nova_rubrica" value="Nova no projeto"
                                severity="contrast"
                                class="bg-transparent border-1 border-solid border-600 text-600 font-normal text-xs" />
                        </div>
                    </template>
                </Column>
                <Column field="valor" header="Valor" style="width: 160px; text-align: end;">
                    <template #body="{ data }">
                        <ColunaListas :titulo="formataMoedaReais(data.valor)" />
                    </template>
                </Column>
            </DataTable>
        </TabelaScrollContainer>
    </div>
</template>
